import { IEventMarket1X2FromWS } from '@/types/event';
import { BetSelection } from '@/constants';
import { AbstractMarket } from '@/models/abstractMarket';

export class Market1X2Item extends AbstractMarket {
    public homePrice: string | null;
    public awayPrice: string | null;
    public drawPrice: string | null;
    public homeBookmakerId: number | null;
    public awayBookmakerId: number | null;
    public drawBookmakerId: number | null;
    public homePriceList: [number, number][] | null;
    public awayPriceList: [number, number][] | null;
    public drawPriceList: [number, number][] | null;
    public feedCount: number;
    public marginPerc: string | null;

    constructor(data: IEventMarket1X2FromWS) {
        super();

        this.setPreviousPrice(BetSelection.OneXTwoHome, data.price_home_max);
        this.setPreviousPrice(BetSelection.OneXTwoAway, data.price_away_max);
        this.setPreviousPrice(BetSelection.OneXTwoDraw, data.price_draw_max);

        this.homePrice = data.price_home_max;
        this.awayPrice = data.price_away_max;
        this.drawPrice = data.price_draw_max;
        this.homeBookmakerId = data.price_home_max_site_id;
        this.awayBookmakerId = data.price_away_max_site_id;
        this.drawBookmakerId = data.price_draw_max_site_id;
        this.homePriceList = data.price_home_list ? JSON.parse(data.price_home_list) : null;
        this.awayPriceList = data.price_away_list ? JSON.parse(data.price_away_list) : null;
        this.drawPriceList = data.price_draw_list ? JSON.parse(data.price_draw_list) : null;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }

    public update(data: IEventMarket1X2FromWS) {
        this.setPreviousPrice(BetSelection.OneXTwoHome, this.homePrice);
        this.setPreviousPrice(BetSelection.OneXTwoAway, this.awayPrice);
        this.setPreviousPrice(BetSelection.OneXTwoDraw, this.drawPrice);

        this.homePrice = data.price_home_max;
        this.awayPrice = data.price_away_max;
        this.drawPrice = data.price_draw_max;
        this.homeBookmakerId = data.price_home_max_site_id;
        this.awayBookmakerId = data.price_away_max_site_id;
        this.drawBookmakerId = data.price_draw_max_site_id;
        this.homePriceList = data.price_home_list ? JSON.parse(data.price_home_list) : null;
        this.awayPriceList = data.price_away_list ? JSON.parse(data.price_away_list) : null;
        this.drawPriceList = data.price_draw_list ? JSON.parse(data.price_draw_list) : null;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }
}
